import { render, staticRenderFns } from "./VerifyEmailRegisterMobile.vue?vue&type=template&id=2b880572&"
import script from "./VerifyEmailRegisterMobile.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailRegisterMobile.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmailRegisterMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports